import React from "react"

import { CategoriesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"


export default function ReportCategoriesField() {
	const {
		filterCategories,
		setFilterCategoriesInfo,
		error
	} = useReportFormInfo(reportFormData.peek().filterCategories, "filterCategories", object({ filterCategories: array().nullable() }))

	return <CategoriesAutocomplete
		value={filterCategories}
		onChange={e => setFilterCategoriesInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/category`}
	/>
}